import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import 'moment-duration-format';


@Pipe({
  name: 'secondToDaysHoursMinutes',
  standalone: true
})
export class SecondToDaysHoursMinutes implements PipeTransform {

  transform(seconds: number): string {
    if (seconds == null || seconds <= 0) {
      return '-';
    }
    // Create a Moment.js duration object from the seconds
    const duration = moment.duration(seconds, 'seconds');

    return duration.format('d[d] h[h] m[m]');
  }

}
